import { Directive, TemplateRef, input } from '@angular/core';

@Directive({
	selector: 'ng-template[aePgtStateNoItems]',
})
export class PaginationTableStateNoItemsDirective {
	readonly disabled = input(false);

	constructor(public template: TemplateRef<any>) {}
}
